(() => {
  var themeSettings = (window.theme && window.theme.settings) || {};

  var getProductData = function () {
    if (window.meta && window.meta.product) return window.meta.product;
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
      return window.ShopifyAnalytics.meta.product;
    }

    var pickerJson = document.querySelector('variant-picker script[type="application/json"]');
    if (pickerJson) {
      try {
        var parsed = JSON.parse(pickerJson.textContent || '{}');
        if (parsed && parsed.product) return parsed.product;
      } catch (e) {
        /* ignore parse errors */
      }
    }

    var productJsonScript = document.querySelector('[id^="product-json-"]');
    if (productJsonScript) {
      try {
        return JSON.parse(productJsonScript.textContent || '{}');
      } catch (e) {
        return null;
      }
    }

    return null;
  };

  var toNumber = function (value) {
    var num = Number(value);
    return Number.isFinite(num) ? num : null;
  };

  var parsePriceToCents = function (text) {
    var digits = (text || '').match(/\d+/g);
    if (!digits) return null;

    var cents = Number(digits.join(''));
    return Number.isFinite(cents) ? cents : null;
  };

  var formatMoney = function (cents) {
    var value = Math.round(cents);
    var sign = value < 0 ? '-' : '';
    var absolute = Math.abs(value);
    var integerPart = Math.floor(absolute / 100);
    var decimalPart = (absolute % 100).toString().padStart(2, '0');
    var integerWithDots = integerPart.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return sign + integerWithDots + ',' + decimalPart + '€';
  };

  var applyDiscountToPrice = function (priceEl, baseCents, options) {
    var opts = options || {};
    var currentEl = priceEl.querySelector('.price__current');
    if (!currentEl) return;

    var storedBase = toNumber(priceEl.dataset.packDiscountBase);
    var base =
      Number.isFinite(baseCents) && baseCents > 0
        ? baseCents
        : storedBase || parsePriceToCents(currentEl.textContent);

    if (!Number.isFinite(base) || base <= 0) return;

    priceEl.dataset.packDiscountBase = base;
    var discounted = Math.round(base * DISCOUNT_RATE);
    priceEl.dataset.packDiscountValue = discounted;
    priceEl.dataset.packDiscountSeen = base;

    var formattedCurrent = formatMoney(discounted);
    priceEl.dataset.packDiscountUpdating = 'true';
    currentEl.innerHTML = formattedCurrent;

    var wasEl = priceEl.querySelector('.price__was');
    var compareBase = Number.isFinite(opts.compareAt) && opts.compareAt > 0 ? opts.compareAt : base;

    if (wasEl && compareBase) {
      priceEl.dataset.packDiscountCompare = compareBase;
      wasEl.innerHTML = formatMoney(compareBase);
      priceEl.classList.toggle('price--on-sale', discounted < compareBase);
    }

    var unitEl = priceEl.querySelector('.unit-price__price');
    if (unitEl) {
      var unitBase =
        Number.isFinite(opts.unitPrice) && opts.unitPrice > 0 ? opts.unitPrice : toNumber(priceEl.dataset.packDiscountUnit);

      if (unitBase) {
        priceEl.dataset.packDiscountUnit = unitBase;
        unitEl.innerHTML = formatMoney(Math.round(unitBase * DISCOUNT_RATE));
      }
    }

    priceEl.dataset.packDiscountUpdating = '';
  };

  var observePrice = function (priceEl) {
    var observer = new MutationObserver(function () {
      if (priceEl.dataset.packDiscountUpdating === 'true') return;

      var currentEl = priceEl.querySelector('.price__current');
      if (!currentEl) return;

      var currentCents = parsePriceToCents(currentEl.textContent);
      var appliedCents = toNumber(priceEl.dataset.packDiscountValue);

      if (appliedCents && currentCents === appliedCents) return;

      applyDiscountToPrice(priceEl, currentCents);
    });

    observer.observe(priceEl, { childList: true, characterData: true, subtree: true });
  };

  var initAttempts = 0;
  var MAX_ATTEMPTS = 15;
  var DISCOUNT_RATE = 0.9;

  var tryInit = function () {
    initAttempts += 1;

    var productData = getProductData();
    var selectors = ['.product-info__price > .price', '.sticky-atc-panel .price'];
    var priceElements = selectors
      .map(function (selector) {
        return Array.prototype.slice.call(document.querySelectorAll(selector));
      })
      .reduce(function (acc, list) {
        return acc.concat(list);
      }, []);

    var hasPackFlag = !!document.querySelector('[data-pack-descuento]');

    if (!productData && !hasPackFlag) {
      if (initAttempts < MAX_ATTEMPTS) {
        setTimeout(tryInit, 200);
      }
      return false;
    }

    var productTags = (productData && productData.tags) || [];
    var normalisedTags = Array.isArray(productTags)
      ? productTags.map(function (tag) {
          return String(tag).trim().toLowerCase();
        })
      : [];

    var isPackProduct = hasPackFlag || normalisedTags.indexOf('pack_descuento') !== -1;
    if (!isPackProduct) return true;

    if (priceElements.length === 0) {
      if (initAttempts < MAX_ATTEMPTS) {
        setTimeout(tryInit, 200);
      }
      return false;
    }

    var variants = (productData && productData.variants) || [];
    var getVariantById = function (variantId) {
      return variants.find(function (variant) {
        return variant.id === variantId;
      });
    };

    var applyVariantPrices = function (variant) {
      if (!variant) return;
      priceElements.forEach(function (priceEl) {
        applyDiscountToPrice(priceEl, variant.price, {
          compareAt: variant.price,
          unitPrice: variant.unit_price
        });
      });
    };

    priceElements.forEach(function (priceEl) {
      priceEl.dataset.packDiscount = 'true';
      observePrice(priceEl);
    });

    var variantInput =
      document.querySelector('.js-product-form-main input[name="id"]') || document.querySelector('input[name="id"]');
    var initialVariantId = variantInput ? Number(variantInput.value) : NaN;

    applyVariantPrices(getVariantById(initialVariantId) || variants[0] || null);

    if (!variants.length) {
      priceElements.forEach(function (priceEl) {
        applyDiscountToPrice(priceEl);
      });
    }

    document.addEventListener('on:variant:change', function (evt) {
      if (!evt || !evt.detail || !evt.detail.variant) return;
      applyVariantPrices(evt.detail.variant);
    });

    return true;
  };

  tryInit();

  var reattachObserver = new MutationObserver(function (mutations) {
    var shouldRetry = mutations.some(function (mutation) {
      if (mutation.addedNodes && mutation.addedNodes.length) {
        return Array.prototype.some.call(mutation.addedNodes, function (node) {
          if (!(node instanceof HTMLElement)) return false;
          if (node.matches && (node.matches('.product-info__price') || node.matches('.product-info__price .price'))) {
            return true;
          }
          return !!node.querySelector && node.querySelector('.product-info__price');
        });
      }
      return false;
    });

    if (shouldRetry) tryInit();
  });

  reattachObserver.observe(document.body, { childList: true, subtree: true });
})();
